<!-- Wrapper Start -->
<div class="wrapper">
    <div class="container-fluid p-0">
        <div class="row no-gutters">
            <div class="col-sm-12 text-center">
                <div class="iq-error">
                    <h4 class="mb-0">No menus available</h4>
                    <p>Your administrator has not enabled any modules for your account. Please contact them for access.</p>
                    <a class="btn btn-outline-primary mt-3" (click)="logout()">
                        <i class="ri-logout-box-line"></i>Back to Login
                    </a>
                    <img src="./assets/images/error/01.png" class="img-fluid error-img" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Wrapper END -->
